/**
 * PostHog Analytics Initialization for Backoffice App
 *
 * Sets up PostHog analytics to run side-by-side with existing tracking.
 * Call initPostHog() after DI is ready.
 */

import { resolve } from "ui-common/di";
import type { IPostHogService } from "ui-common/services/posthog/types";

/**
 * Initialize PostHog for the backoffice app.
 * Should be called in requestAnimationFrame block after DI is ready.
 */
export function initPostHog(): void {
  const posthogService = resolve<IPostHogService>("posthogService");

  // Initialize PostHog SDK
  posthogService.initialize();

  // Register backoffice-specific super properties
  posthogService.registerSuperProperties({
    app: "backoffice",
  });
}
